import AntButton from "antd/es/button";
import styled, { css } from "styled-components";
import { disabledStyle } from "common/Buttons/styles";
import { hexToRGB } from "@shared/utils/misc";
import { BOTTOM_NAVIGATOR } from "common/constants";

export const buttonStyles = {
  antBtn: css`
    background: ${(p) => p.theme.colors.cardBgColor};
    color: ${(p) => p.theme.colors.textColor};
    border-color: ${(p) => p.theme.colors.mediumBorderGrey};
    &:hover {
      @media (min-width: ${BOTTOM_NAVIGATOR}) {
        color: ${(p) => p.theme.colors.primaryBlue};
        border-color: ${(p) => p.theme.colors.primaryBlue};
        background: ${(p) => p.theme.colors.cardBgColor};
      }
    }
  `,
  antBtnPrimary: css`
    background: ${(p) => p.theme.colors.primaryBlue} !important;
    border-color: ${(p) => p.theme.colors.primaryBlue} !important;
    color: ${(p) => p.theme.colors.buttonText} !important;
    &:hover {
      @media (min-width: ${BOTTOM_NAVIGATOR}) {
        background: ${(p) =>
          hexToRGB(p.theme.colors.primaryBlue, 0.85)} !important;
        border-color: ${(p) => p.theme.colors.primaryBlue} !important;
        color: ${(p) => p.theme.colors.buttonText} !important;
      }
    }
  `,
  antBtnDefault: css`
    &:not(:disabled):not(.ant-btn-disabled):hover {
      @media (min-width: ${BOTTOM_NAVIGATOR}) {
        color: ${(p) => p.theme.colors.primaryBlue};
        border-color: ${(p) => p.theme.colors.primaryBlue};
        background: inherit;
      }
    }
  `,
  antBtnDangerous: css`
    border-color: ${(p) => p.theme.colors.red} !important;
    color: ${(p) => p.theme.colors.red} !important;
    &:hover {
      border-color: ${(p) => p.theme.colors.red} !important;
      color: ${(p) => hexToRGB(p.theme.colors.red, 0.7)} !important;
    }
  `,
  antBtnDisabled: css`
    opacity: 0.4;
    &:hover {
      color: ${(p) => p.theme.colors.buttonText};
      @media (min-width: ${BOTTOM_NAVIGATOR}) {
        border-color: ${(p) => p.theme.colors.mediumBorderGrey};
        color: ${(p) => p.theme.colors.textColor};
      }
    }
  `,
};

const Button = styled(AntButton)<{
  $size?: "l";
  $error?: boolean;
  $type?: "secondary" | "outlined";
}>`
  &.ant-btn.ant-btn-loading::before {
    display: none;
  }
  &.ant-btn {
    ${buttonStyles.antBtn};
  }
  &.ant-btn-primary {
    ${buttonStyles.antBtnPrimary};
  }
  &.ant-btn-link {
    border: none;
    color: ${(p) => p.theme.colors.primaryBlue} !important;
  }
  &.ant-btn-default {
    ${buttonStyles.antBtnDefault};
  }
  &.ant-btn-dangerous {
    ${buttonStyles.antBtnDangerous};
  }
  &.ant-btn[disabled] {
    ${buttonStyles.antBtnDisabled};
  }
  ${(p) =>
    p.$size === "l" &&
    `
    height: 40px;
    font-size: ${p.theme.typography.fontSizes.L};
  `}

  ${(p) => p.$error && disabledStyle}
  ${(p) =>
    p.$error &&
    `
    &:hover {
        border-color: ${p.theme.colors.mediumBorderGrey} !important;
        color: ${p.theme.colors.textColor} !important;
    }
  `}
  ${(p) =>
    p.$type === "secondary" &&
    `
    background: ${hexToRGB(p.theme.colors.primaryBlue, 0.12)} !important;
    color: ${p.theme.colors.primaryBlue} !important;
    border: none;
  `}
  ${(p) =>
    p.$type === "outlined" &&
    `
    font-weight: 500;
    background: transparent !important;
    color: ${p.theme.colors.primaryBlue} !important;
    border-color: ${p.theme.colors.primaryBlue} !important;
    &:hover {
      border-color: ${p.theme.colors.primaryBlue};
    }
  `}
`;

export default Button;

export const StyledDefaultButton = styled(Button)`
  &.ant-btn-default {
    background: ${(p) => hexToRGB(p.theme.colors.primaryBlue, 0.1)} !important;
    color: ${(p) => p.theme.colors.primaryBlue} !important;
    border: none;
    box-shadow: none;
  }

  &.ant-btn-default:not(:disabled):not(.ant-btn-disabled):hover {
    @media (min-width: ${BOTTOM_NAVIGATOR}) {
      background: ${(p) =>
        hexToRGB(p.theme.colors.primaryBlue, 0.15)} !important;
    }
  }

  &.ant-btn > .ant-btn-loading-icon .anticon svg {
    color: ${(p) => p.theme.colors.primaryBlue};
  }
`;
